import { getAccessTokenSilentlyRef } from '@/api';
import { LoaderFunction, LoaderFunctionArgs, redirect } from 'react-router';
import { ROUTES } from '@/constants.ts';

export function withAuth(loader: LoaderFunction) {
	return async (args: LoaderFunctionArgs) => {
		if (!getAccessTokenSilentlyRef) {
			return null;
		}

		const token = await getAccessTokenSilentlyRef();

		if (!token) {
			const url = new URL(args.request.url);
			const returnTo = `${url.pathname}${url.search || ''}`;
			const loginUrl = `${ROUTES.login}?returnTo=${encodeURIComponent(returnTo)}`;
			throw redirect(loginUrl);
		}

		if (loader) {
			return loader(args);
		}

		return null;
	};
}
